import { useEffect, useContext, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import GaugeChart from 'react-gauge-chart';

import ServerError from '../layout/ServerError';
// import SearchMetrics from '../trophys/SearchMetrics';
import Spinner from '../layout/Spinner';
import BackToTop from '../layout/BackToTop';
import Utility from '../util/Utility';
import TTBarChartAllYears from '../containers/TTChartAllYears';
import MiniHeroSection from '../containers/MiniHeroSection';

import TrophysContext from '../../context/trophys/trophysContext';

const Stats = () => {
  const trophysContext = useContext(TrophysContext);
  const { loading, metrics } = trophysContext;

  const [selectedListSellerIndex, setSelectedListSellerIndex] = useState(0);
  const [chartTypeSeller, setChartTypeSeller] = useState('bar');
  const [chartDataDisplaySeller, setChartDataDisplaySeller] =
    useState('avgPrice');

  const GotoNextSellerYear = () => {
    if (
      selectedListSellerIndex <
      metrics.info.listedSellerPricesByYear.length - 1
    ) {
      setSelectedListSellerIndex(selectedListSellerIndex + 1);
    }
  };

  const GotoPrevSellerYear = () => {
    if (selectedListSellerIndex > 0) {
      setSelectedListSellerIndex(selectedListSellerIndex - 1);
    }
  };

  const GotoFirstSellerYear = () => {
    setSelectedListSellerIndex(0);
  };

  const GotoLastSellerYear = () => {
    setSelectedListSellerIndex(
      metrics.info.listedSellerPricesByYear.length - 1,
    );
  };

  const swipeHandlersSeller = useSwipeable({
    onSwipedLeft: (eventData) => {
      GotoNextSellerYear();
    },

    onSwipedRight: (eventData) => {
      GotoPrevSellerYear();
    },
  });

  const OnChangeChartTypeSeller = (evt) => setChartTypeSeller(evt.target.value);
  const OnChangeChartDataDisplaySeller = (evt) =>
    setChartDataDisplaySeller(evt.target.value);

  //>>

  const [selectedListBuyerIndex, setSelectedListBuyerIndex] = useState(0);
  const [chartTypeBuyer, setChartTypeBuyer] = useState('bar');
  const [chartDataDisplayBuyer, setChartDataDisplayBuyer] =
    useState('avgPrice');

  const GotoNextBuyerYear = () => {
    if (
      selectedListBuyerIndex <
      metrics.info.listedBuyerPricesByYear.length - 1
    ) {
      setSelectedListBuyerIndex(selectedListBuyerIndex + 1);
    }
  };

  const GotoPrevBuyerYear = () => {
    if (selectedListBuyerIndex > 0) {
      setSelectedListBuyerIndex(selectedListBuyerIndex - 1);
    }
  };

  const GotoFirstBuyerYear = () => {
    setSelectedListBuyerIndex(0);
  };

  const GotoLastBuyerYear = () => {
    setSelectedListBuyerIndex(metrics.info.listedBuyerPricesByYear.length - 1);
  };

  const swipeHandlersBuyer = useSwipeable({
    onSwipedLeft: (eventData) => {
      GotoNextBuyerYear();
    },

    onSwipedRight: (eventData) => {
      GotoPrevBuyerYear();
    },
  });

  const OnChangeChartTypeBuyer = (evt) => setChartTypeBuyer(evt.target.value);
  const OnChangeChartDataDisplayBuyer = (evt) =>
    setChartDataDisplayBuyer(evt.target.value);

  //>>

  // Convert month number to name
  const GetMonthName = (monthStr) => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return months[parseInt(monthStr) - 1];
  };

  //>>

  useEffect(() => {
    !metrics &&
      (async () => {
        await trophysContext.searchMetrics();
      })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-5">
      <MiniHeroSection
        titleText="Stats"
        sectionClassExtra="mb-4"
        iconName="fa-calculator"
      />

      <div className="container">
        <p>
          Please note that the statistics we provide are based on the data we
          currently hold. We cannot guarantee the accuracy of the data.
        </p>

        <ServerError />
        {/* <SearchMetrics /> */}

        {loading && <Spinner />}

        {metrics && (
          <>
            {!metrics.found ? (
              <div className="card border-warning mt-4">
                <div className="card-body">
                  <h5 className="card-title text-white">{metrics.info}</h5>
                  <p className="card-text">Please try again later.</p>
                </div>
              </div>
            ) : (
              <div className="mt-3">
                <h3 className="text-warning">General</h3>
                <div>General statistics and metrics.</div>

                <div className="row text-center">
                  <div className="col-xs-12 col-sm-6 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        <GaugeChart
                          id="gauge-chart-num-recorded"
                          hideText={true}
                          needleColor="#7F7F7F"
                          needleBaseColor="#9F9F9F"
                          colors={['#7F7F7F', '#AE0001']}
                          nrOfLevels={500}
                          arcsLength={[
                            parseFloat(metrics.info.numTrophys) / 500.0,
                            1.0 - parseFloat(metrics.info.numTrophys) / 500.0,
                          ]}
                          percent={parseFloat(metrics.info.numTrophys) / 500.0}
                        />
                        <h4 className="text-white"># Recorded Trophys</h4>
                        <h2 className="text-warning mb-0">
                          {metrics.info.numTrophys}
                          <small style={{ opacity: '0.75' }}> / 500</small>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        <GaugeChart
                          id="gauge-chart-num-scrapped"
                          hideText={true}
                          needleColor="#7F7F7F"
                          needleBaseColor="#9F9F9F"
                          colors={['#AE0001', '#7F7F7F']}
                          nrOfLevels={500}
                          arcsLength={[
                            parseFloat(metrics.info.numScrapped) / 500.0,
                            1.0 - parseFloat(metrics.info.numScrapped) / 500.0,
                          ]}
                          percent={parseFloat(metrics.info.numScrapped) / 500.0}
                        />
                        <h4 className="text-white"># Scrapped Trophys</h4>
                        <h2 className="text-warning mb-0">
                          {metrics.info.numScrapped}
                          <small style={{ opacity: '0.75' }}> / 500</small>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row text-center">
                  <div className="col-xs-12 col-sm-12 col-md-4 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        <h4 className="text-white">Lowest Mileage</h4>
                        <h4 className="text-warning mb-0">
                          {Utility.numWithCommas(metrics.info.minMileage)}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-4 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        <h4 className="text-white">Average Mileage</h4>
                        <h4 className="text-warning mb-0">
                          {Utility.numWithCommas(metrics.info.avgMileage)}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-4 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        <h4 className="text-white">Highest Mileage</h4>
                        <h4 className="text-warning mb-0">
                          {Utility.numWithCommas(metrics.info.maxMileage)}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 className="mt-5 text-warning">
                  Registrations by Month and Year
                </h3>
                <div className="fw-bold mb-3">
                  A breakdown of the number of Trophys registered by month and
                  year.
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-sm-6">
                    <h4 className="text-white mb-3">2005 Registrations</h4>
                    <div className="card bg-body-tertiary shadow mb-3">
                      <div className="card-body text-center">
                        <h4 className="text-white">Earliest Registered</h4>
                        <h4 className="text-warning mb-0">
                          {new Date(
                            metrics.info.earliestRegistration,
                          ).toLocaleDateString(undefined, {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
                        </h4>
                      </div>
                    </div>

                    <table className="table table-bordered border-tertiary table-striped shadow mb-0">
                      <thead>
                        <tr>
                          <th className="text-warning">Month</th>
                          <th className="text-warning text-center">
                            Cars Registered
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-group-divider text-warning">
                        {metrics.info.numMonthly2005Registrations && (
                          <>
                            {Object.entries(
                              metrics.info.numMonthly2005Registrations,
                            )
                              .sort(([a], [b]) => a.localeCompare(b))
                              .map(([month, count]) => (
                                <tr key={month}>
                                  <td>{GetMonthName(month)}</td>
                                  <td className="text-center">{count}</td>
                                </tr>
                              ))}
                          </>
                        )}
                      </tbody>

                      <tbody className="table-group-divider text-warning">
                        <tr className="text-warning">
                          <td>Total</td>
                          <td className="text-center">
                            {metrics.info.num2005Registrations}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col-sm-6">
                    <h4 className="text-white mb-3">2006 Registrations</h4>
                    <div className="card bg-body-tertiary shadow mb-3">
                      <div className="card-body text-center">
                        <h4 className="text-white">Latest Registered</h4>
                        <h4 className="text-warning mb-0">
                          {new Date(
                            metrics.info.latestRegistration,
                          ).toLocaleDateString(undefined, {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
                        </h4>
                      </div>
                    </div>

                    <table className="table table-bordered border-tertiary table-striped shadow mb-0">
                      <thead>
                        <tr>
                          <th className="text-warning">Month</th>
                          <th className="text-warning text-center">
                            Cars Registered
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-group-divider text-warning">
                        {metrics.info.numMonthly2006Registrations && (
                          <>
                            {Object.entries(
                              metrics.info.numMonthly2006Registrations,
                            )
                              .sort(([a], [b]) => a.localeCompare(b))
                              .map(([month, count]) => (
                                <tr key={month}>
                                  <td>{GetMonthName(month)}</td>
                                  <td className="text-center">{count}</td>
                                </tr>
                              ))}
                          </>
                        )}
                      </tbody>

                      <tbody className="table-group-divider text-warning">
                        <tr className="text-warning">
                          <td>Total</td>
                          <td className="text-center">
                            {metrics.info.num2006Registrations}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <h3 className="mt-5 text-warning">Seller Price Trends</h3>
                <div className="mb-2 text-white fw-bold">
                  The following data is based on known seller listings.
                </div>
                <div className="mt-2">
                  The table and chart below list the minimum, average (mean) and
                  maximum list sale prices across all years.
                </div>

                <div className="row text-center">
                  <div className="col-12 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        {metrics.info.listedSellerPricesByYear && (
                          <>
                            <div className="row">
                              <div className="col-12 mb-3 d-flex flex-row justify-content-center align-items-center">
                                <h4 className="mb-0 text-white">
                                  {
                                    metrics.info.listedSellerPricesByYear[0]
                                      .year
                                  }{' '}
                                  -{' '}
                                  {
                                    metrics.info.listedSellerPricesByYear[
                                      metrics.info.listedSellerPricesByYear
                                        .length - 1
                                    ].year
                                  }
                                </h4>
                                <h5 className="mb-0 ms-2 text-secondary">
                                  (based on ALL listings)
                                </h5>
                              </div>

                              <div className="col-12">
                                <div className="row mb-2">
                                  <h5 className="col-4 text-warning mb-0">
                                    Min (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Avg (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Max (£)
                                  </h5>
                                </div>

                                <div className="row py-1 bg-dark">
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.minListSellerPrice,
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.avgListSellerPrice,
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.maxListSellerPrice,
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row g-3 my-3 text-start">
                              <div className="col-sm-6">
                                <label
                                  htmlFor="chartTypeSeller"
                                  className="form-label"
                                >
                                  Chart Type
                                </label>
                                <select
                                  className="form-control form-control-lg custom-select"
                                  id="chartTypeSeller"
                                  defaultValue={chartTypeSeller}
                                  onChange={OnChangeChartTypeSeller}
                                >
                                  <option defaultValue value="bar">
                                    Bar
                                  </option>
                                  <option value="line">Line</option>
                                </select>
                              </div>
                              <div className="col-sm-6">
                                <label
                                  htmlFor="priceDisplaySeller"
                                  className="form-label"
                                >
                                  Prices to Display
                                </label>
                                <select
                                  className="form-control form-control-lg custom-select"
                                  id="priceDisplaySeller"
                                  defaultValue={chartDataDisplaySeller}
                                  onChange={OnChangeChartDataDisplaySeller}
                                >
                                  <option value="minPrice">Minimum</option>
                                  <option value="avgPrice">Average</option>
                                  <option value="maxPrice">Maximum</option>
                                  <option value="combinedPrice">
                                    Combined
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <TTBarChartAllYears
                                  listPricesByYear={
                                    metrics.info.listedSellerPricesByYear
                                  }
                                  chartType={chartTypeSeller}
                                  chartDataDisplay={chartDataDisplaySeller}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  The table below lists the minimum, average (mean) and maximum
                  list sale prices by year. Swipe or use the buttons to cycle
                  through the years.
                </div>

                <div className="row text-center">
                  <div className="col-12 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        {metrics.info.listedSellerPricesByYear && (
                          <>
                            <div className="row" {...swipeHandlersSeller}>
                              <div className="col-12 mb-3 d-flex flex-row justify-content-center align-items-center">
                                <h4 className="mb-0 text-white">
                                  {
                                    metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].year
                                  }
                                </h4>
                                <h5 className="mb-0 ms-2 text-secondary">
                                  (based on{' '}
                                  {Utility.getPluralisedWithValueIfNeeded(
                                    'listing',
                                    metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].numListings,
                                  )}
                                  )
                                </h5>
                              </div>

                              <div className="col-12">
                                <div className="row mb-2">
                                  <h5 className="col-4 text-warning mb-0">
                                    Min (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Avg (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Max (£)
                                  </h5>
                                </div>

                                <div className="row py-1 bg-dark">
                                  <div className="col-4">
                                    {metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedSellerPricesByYear[
                                            selectedListSellerIndex
                                          ].minPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedSellerPricesByYear[
                                            selectedListSellerIndex
                                          ].avgPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedSellerPricesByYear[
                                            selectedListSellerIndex
                                          ].maxPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex flex-row justify-content-between align-items-center mt-3">
                              <div>
                                <button
                                  className="btn btn-dark me-1"
                                  disabled={selectedListSellerIndex === 0}
                                  onClick={() => GotoFirstSellerYear()}
                                >
                                  <i className="fa-solid fa-step-backward"></i>
                                </button>
                                <button
                                  className="btn btn-dark"
                                  disabled={selectedListSellerIndex === 0}
                                  onClick={() => GotoPrevSellerYear()}
                                >
                                  <i className="fa-solid fa-chevron-circle-left"></i>
                                </button>
                              </div>
                              <div className="text-secondary">
                                <small>
                                  {selectedListSellerIndex + 1} of{' '}
                                  {metrics.info.listedSellerPricesByYear.length}
                                </small>
                              </div>
                              <div>
                                <button
                                  className="btn btn-dark"
                                  disabled={
                                    selectedListSellerIndex >=
                                    metrics.info.listedSellerPricesByYear
                                      .length -
                                      1
                                  }
                                  onClick={() => GotoNextSellerYear()}
                                >
                                  <i className="fa-solid fa-chevron-circle-right"></i>
                                </button>
                                <button
                                  className="btn btn-dark ms-1"
                                  disabled={
                                    selectedListSellerIndex >=
                                    metrics.info.listedSellerPricesByYear
                                      .length -
                                      1
                                  }
                                  onClick={() => GotoLastSellerYear()}
                                >
                                  <i className="fa-solid fa-step-forward"></i>
                                </button>
                              </div>
                            </div>

                            <div className="mt-3">
                              <button
                                className="btn btn-secondary btn-lg"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseSellers"
                                aria-expanded="false"
                                aria-controls="collapseSellers"
                              >
                                Toggle Listings
                              </button>
                            </div>

                            <div className="collapse mt-3" id="collapseSellers">
                              {!metrics.info.listedSellerPricesByYear[
                                selectedListSellerIndex
                              ].listings ? (
                                <div className="text-muted">
                                  No listings for{' '}
                                  {
                                    metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].year
                                  }
                                </div>
                              ) : (
                                <table className="table table-bordered border-tertiary table-striped small shadow mb-0">
                                  <thead>
                                    <tr>
                                      <th className="text-warning">#</th>
                                      <th className="text-warning">Date</th>
                                      <th className="text-warning">Mileage</th>
                                      <th className="text-warning">
                                        Price (&pound;)
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="table-group-divider text-warning">
                                    {metrics.info.listedSellerPricesByYear[
                                      selectedListSellerIndex
                                    ].listings.map((listItem, listItemIdx) => {
                                      return (
                                        <tr key={listItemIdx}>
                                          <td>
                                            {listItem.trophyId
                                              .toString()
                                              .padStart(3, '0')}
                                          </td>
                                          <td>
                                            {new Date(
                                              listItem.date,
                                            ).toLocaleDateString(undefined, {
                                              day: '2-digit',
                                              month: '2-digit',
                                              year: 'numeric',
                                            })}
                                          </td>
                                          <td>
                                            {listItem.mileage !== '-1' ? (
                                              <>
                                                {Utility.numWithCommas(
                                                  listItem.mileage,
                                                )}
                                              </>
                                            ) : (
                                              <div className="text-secondary">
                                                No data
                                              </div>
                                            )}
                                          </td>
                                          <td>
                                            {Utility.decimalWithCommas(
                                              listItem.price,
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <h3 className="mt-5 text-warning">Buyer Price Trends</h3>
                <div className="mb-2 text-white fw-bold">
                  The following data is based on known purchases.
                </div>
                <div className="mt-2">
                  The table and chart below list the minimum, average (mean) and
                  maximum purchase prices across all years.
                </div>

                <div className="row text-center">
                  <div className="col-12 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        {metrics.info.listedBuyerPricesByYear && (
                          <>
                            <div className="row">
                              <div className="col-12 mb-3 d-flex flex-row justify-content-center align-items-center">
                                <h4 className="mb-0 text-white">
                                  {metrics.info.listedBuyerPricesByYear[0].year}{' '}
                                  -{' '}
                                  {
                                    metrics.info.listedBuyerPricesByYear[
                                      metrics.info.listedBuyerPricesByYear
                                        .length - 1
                                    ].year
                                  }
                                </h4>
                                <h5 className="mb-0 ms-2 text-secondary">
                                  (based on ALL listings)
                                </h5>
                              </div>

                              <div className="col-12">
                                <div className="row mb-2">
                                  <h5 className="col-4 text-warning mb-0">
                                    Min (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Avg (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Max (£)
                                  </h5>
                                </div>

                                <div className="row py-1 bg-dark">
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.minListBuyerPrice,
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.avgListBuyerPrice,
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {Utility.decimalWithCommas(
                                      metrics.info.maxListBuyerPrice,
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row g-3 my-3 text-start">
                              <div className="col-sm-6">
                                <label
                                  htmlFor="chartTypeBuyer"
                                  className="form-label"
                                >
                                  Chart Type
                                </label>
                                <select
                                  className="form-control form-control-lg custom-select"
                                  id="chartTypeBuyer"
                                  defaultValue={chartTypeBuyer}
                                  onChange={OnChangeChartTypeBuyer}
                                >
                                  <option defaultValue value="bar">
                                    Bar
                                  </option>
                                  <option value="line">Line</option>
                                </select>
                              </div>
                              <div className="col-sm-6">
                                <label
                                  htmlFor="priceDisplayBuyer"
                                  className="form-label"
                                >
                                  Prices to Display
                                </label>
                                <select
                                  className="form-control form-control-lg custom-select"
                                  id="priceDisplayBuyer"
                                  defaultValue={chartDataDisplayBuyer}
                                  onChange={OnChangeChartDataDisplayBuyer}
                                >
                                  <option value="minPrice">Minimum</option>
                                  <option value="avgPrice">Average</option>
                                  <option value="maxPrice">Maximum</option>
                                  <option value="combinedPrice">
                                    Combined
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <TTBarChartAllYears
                                  listPricesByYear={
                                    metrics.info.listedBuyerPricesByYear
                                  }
                                  chartType={chartTypeBuyer}
                                  chartDataDisplay={chartDataDisplayBuyer}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  The table below lists the minimum, average (mean) and maximum
                  purchase prices by year. Swipe or use the buttons to cycle
                  through the years.
                </div>

                <div className="row text-center">
                  <div className="col-12 mt-3">
                    <div className="card bg-body-tertiary shadow">
                      <div className="card-body">
                        {metrics.info.listedBuyerPricesByYear && (
                          <>
                            <div className="row" {...swipeHandlersBuyer}>
                              <div className="col-12 mb-3 d-flex flex-row justify-content-center align-items-center">
                                <h4 className="mb-0 text-white">
                                  {
                                    metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].year
                                  }
                                </h4>
                                <h5 className="mb-0 ms-2 text-secondary">
                                  (based on{' '}
                                  {Utility.getPluralisedWithValueIfNeeded(
                                    'listing',
                                    metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].numListings,
                                  )}
                                  )
                                </h5>
                              </div>

                              <div className="col-12">
                                <div className="row mb-2">
                                  <h5 className="col-4 text-warning mb-0">
                                    Min (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Avg (£)
                                  </h5>
                                  <h5 className="col-4 text-warning mb-0">
                                    Max (£)
                                  </h5>
                                </div>

                                <div className="row py-1 bg-dark">
                                  <div className="col-4">
                                    {metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedBuyerPricesByYear[
                                            selectedListBuyerIndex
                                          ].minPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedBuyerPricesByYear[
                                            selectedListBuyerIndex
                                          ].avgPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-4">
                                    {metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].numListings > 0 ? (
                                      <>
                                        {Utility.decimalWithCommas(
                                          metrics.info.listedBuyerPricesByYear[
                                            selectedListBuyerIndex
                                          ].maxPrice,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text-secondary">
                                          No data
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex flex-row justify-content-between align-items-center mt-3">
                              <div>
                                <button
                                  className="btn btn-dark me-1"
                                  disabled={selectedListBuyerIndex === 0}
                                  onClick={() => GotoFirstBuyerYear()}
                                >
                                  <i className="fa-solid fa-step-backward"></i>
                                </button>
                                <button
                                  className="btn btn-dark"
                                  disabled={selectedListBuyerIndex === 0}
                                  onClick={() => GotoPrevBuyerYear()}
                                >
                                  <i className="fa-solid fa-chevron-circle-left"></i>
                                </button>
                              </div>
                              <div className="text-secondary">
                                <small>
                                  {selectedListBuyerIndex + 1} of{' '}
                                  {metrics.info.listedBuyerPricesByYear.length}
                                </small>
                              </div>
                              <div>
                                <button
                                  className="btn btn-dark"
                                  disabled={
                                    selectedListBuyerIndex >=
                                    metrics.info.listedBuyerPricesByYear
                                      .length -
                                      1
                                  }
                                  onClick={() => GotoNextBuyerYear()}
                                >
                                  <i className="fa-solid fa-chevron-circle-right"></i>
                                </button>
                                <button
                                  className="btn btn-dark ms-1"
                                  disabled={
                                    selectedListBuyerIndex >=
                                    metrics.info.listedBuyerPricesByYear
                                      .length -
                                      1
                                  }
                                  onClick={() => GotoLastBuyerYear()}
                                >
                                  <i className="fa-solid fa-step-forward"></i>
                                </button>
                              </div>
                            </div>

                            <div className="mt-3">
                              <button
                                className="btn btn-secondary btn-lg"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseBuyers"
                                aria-expanded="false"
                                aria-controls="collapseBuyers"
                              >
                                Toggle Listings
                              </button>
                            </div>

                            <div className="collapse mt-3" id="collapseBuyers">
                              {!metrics.info.listedBuyerPricesByYear[
                                selectedListBuyerIndex
                              ].listings ? (
                                <div className="text-muted">
                                  No listings for{' '}
                                  {
                                    metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].year
                                  }
                                </div>
                              ) : (
                                <table className="table table-bordered border-tertiary table-striped small shadow mb-0">
                                  <thead>
                                    <tr>
                                      <th className="text-warning">#</th>
                                      <th className="text-warning">Date</th>
                                      <th className="text-warning">Mileage</th>
                                      <th className="text-warning">
                                        Price (&pound;)
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="table-group-divider text-warning">
                                    {metrics.info.listedBuyerPricesByYear[
                                      selectedListBuyerIndex
                                    ].listings.map((listItem, listItemIdx) => {
                                      return (
                                        <tr key={listItemIdx}>
                                          <td>
                                            {listItem.trophyId
                                              .toString()
                                              .padStart(3, '0')}
                                          </td>
                                          <td>
                                            {new Date(
                                              listItem.date,
                                            ).toLocaleDateString(undefined, {
                                              day: '2-digit',
                                              month: '2-digit',
                                              year: 'numeric',
                                            })}
                                          </td>
                                          <td>
                                            {listItem.mileage !== '-1' ? (
                                              <>
                                                {Utility.numWithCommas(
                                                  listItem.mileage,
                                                )}
                                              </>
                                            ) : (
                                              <div className="text-secondary">
                                                No data
                                              </div>
                                            )}
                                          </td>
                                          <td>
                                            {Utility.decimalWithCommas(
                                              listItem.price,
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        <BackToTop />
      </div>
    </div>
  );
};

export default Stats;
